import { Component, computed, inject, input, LOCALE_ID, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-filter-item-search',
  imports: [FormsModule],
  templateUrl: './filter-item-search.html',
  styleUrl: './filter-item-search.scss',
})
export class FilterItemSearch {
  private locale = inject(LOCALE_ID);

  label = input.required<string>();
  placeholder = input<string>('');
  isInvalid = input<boolean>(false);

  searchTerm = model.required<string>();

  isArabic = computed(() => this.locale.startsWith('ar'));
}
